import React from 'react';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
  >
    <path
      opacity="0.4"
      d="M6.5 12.5C9.81371 12.5 12.5 9.81371 12.5 6.5C12.5 3.18629 9.81371 0.5 6.5 0.5C3.18629 0.5 0.5 3.18629 0.5 6.5C0.5 9.81371 3.18629 12.5 6.5 12.5Z"
      stroke="#4B4B4B"
    />
    <path
      d="M5.82182 3.39697L5.08325 4.13554L7.4823 6.53983L5.08325 8.94412L5.82182 9.68269L8.96468 6.53983L5.82182 3.39697Z"
      fill="#4B4B4B"
    />
  </svg>
);
